export default __webpack_public_path__ + "1cd257bbea5331120b45bc8385a9002a.png";